<template>
    <div class="sound-console" ref="homeElement">
        <div class="sound-console__nav">
            <router-link class="sound-console__nav-item" to="/">
            <font-awesome-icon :icon="['fas', 'home']" />
                Home
            </router-link>
            <button class="sound-console__nav-item" @click="toggleFullscreen">
                <font-awesome-icon v-if="fullscreen" :icon="['fas', 'compress']" />
                <font-awesome-icon v-else :icon="['fas', 'expand']" />
                {{ fullscreen ? 'Exit' : 'Fullscreen'}}
            </button>

        </div><!-- __nav -->

        <SoundConsoleInstructions
            v-if="activeView == views.VIEW_INSTRUCTIONS"
            @start="handleInstructionsStart" />

        <SoundConsolePlayer
            v-if="activeView == views.VIEW_AUDIO"
            @instructions="activeView = views.VIEW_INSTRUCTIONS"
            @fullscreen="actionFullscreen"
            @video="actionVideo" />

        <div class="video-container"
            v-show="activeView == views.VIEW_VIDEO">
            <video
                ref="video"
                src="/video/ElliotsParkSongWeb.mp4"></video>
        </div><!-- .video-container -->

        <SoundConsoleEnd
            v-if="activeView == views.VIEW_END" />

    </div>
</template>

<style lang="scss" scoped>
    @import '../scss/design.scss';

    .sound-console {
        position: relative;

        &__nav {
            position: absolute;
            z-index: 2;
            top: 10px;
            left: 10px;
            background-color: rgba(white, .65);
            padding: 20px 8px;
            border-radius: 999px;
        }

        &__nav-item {
            display: block;
            width: 60px;
            height: 60px;
            font-size: 10px;
            text-decoration: none;
            color: #333;
            &:hover,
            &:focus {
                color: #666;
            }

            & + & {
                margin-top: 10px;
            }

            svg {
                width: 32px;
                height: 32px;
                display: block;
                margin: 0 auto;
                margin-bottom: 8px;
            }

            text-align: center;
        }
    }

    .video-container {
        position: relative;
        flex: 1 1 auto;

        video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

</style>

<script>
/*
    Features
    [] Play video at end of playlist - Enter fullscreen
    [] General layout file
    [] Style & position sound console
    [] Message from pat video
        [] Vuetensils popover
    [] Song practice Page
    [] Put on a show pages
*/

import AudioButton from '@/components/AudioButton.vue';
import SoundConsoleInstructions from '@/components/SoundConsoleInstructions.vue';
import SoundConsolePlayer from '@/components/SoundConsolePlayer.vue';
import SoundConsoleEnd from '@/components/SoundConsoleEnd.vue';
import GlobalProgress from '@/components/GlobalProgress.vue';
import isFunction from 'lodash/isFunction';
import VideoPlayer from '@/components/VideoPlayer';


// Views
const VIEW_INSTRUCTIONS = 'STATE_INSTRUCTIONS'
const VIEW_AUDIO = 'STATE_AUDIO'
const VIEW_VIDEO = 'STATE_VIDEO'
const VIEW_END = 'STATE_END'

export default {
    components: {
        SoundConsoleInstructions,
        SoundConsolePlayer,
        SoundConsoleEnd,
        VideoPlayer
    },
    data() {
        let vm = this;
        return {
            fullscreen: false,
            views: {
                VIEW_INSTRUCTIONS,
                VIEW_AUDIO,
                VIEW_VIDEO,
                VIEW_END
            },
            activeView: VIEW_INSTRUCTIONS,
        };
    },
    watch: {
        fullscreen(newVal, oldVal) {
            if(newVal === true && !document.fullscreen) {
                this.requestFullscreen();
            }

            if(!newVal && document.fullscreen) {
                this.exitFullscreen();
            }
        }
    },
    mounted() {
        this.$refs.video.addEventListener('ended', this.actionVideoEnd)
    },
    beforeDestroy() {
        this.$refs.video.removeEventListener('ended', this.actionVideoEnd)
    },
    methods: {
        handleInstructionsStart() {
            this.activeView = VIEW_AUDIO;
        },
        requestFullscreen() {
            if(!document.fullscreen) {
                this.$refs.homeElement.requestFullscreen().then(()=>{
                    console.log('You are fullscreen');
                });
            }
        },
        exitFullscreen() {
            if(document.fullscreen) {
                document.exitFullscreen().then(()=>{
                    console.log('you have exited');
                })
            }
        },
        toggleFullscreen() {
            this.fullscreen = !this.fullscreen;
        },
        actionFullscreen() {
            this.fullscreen = true;
        },
        actionVideo() {
            let vm = this;
            this.activeView = VIEW_VIDEO;

            this.$nextTick(() => {
                this.$refs.video.play();
            })
        },
        actionVideoEnd() {
            this.activeView = VIEW_END;
            this.$refs.video.removeEventListener('ended', this.actionVideoEnd);
        }
    }
};
</script>
